import AppResource from "ss-js-engine/src/Data/AppResource";
import WildAppResource from "./WildAppResource";
import UserAppResource from "./UserAppResource";
import HomeSaleLegalProtectionAppResource from './HomeSaleLegalProtectionAppResource';
import EscrowOfficerAppResource from './EscrowOfficerAppResource';
import DisclosureAppResource from './DisclosureAppResource';
import InvitationAppResource from './InvitationAppResource';
import OrderPropertyAppResource from "./OrderPropertyAppResource";
import SellerAppResource from "./SellerAppResource";
import SignDisclosureAppResource from "./SignDisclosureAppResource";
import LuOrderedByTypeAppResource from "./LuOrderedByTypeAppResource";
import LuOrderStatusAppResource from "./LuOrderStatusAppResource";
import LuOrderSolutionAppResource from "./LuOrderSolutionAppResource";
import LuOrderPaymentTermAppResource from "./LuOrderPaymentTermAppResource";
import LuDisclosureFormAppResource from "./LuDisclosureFormAppResource";
import BrokerAppResource from "./BrokerAppResource";
import FormAppResource from "./FormAppResource";
import Engine from "ss-js-engine/src/Engine";
import get from "lodash/get";

class OrderAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'order';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'orders';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
            'integrations',
            'integrationsContextId',
            'integrationsPlatformId',
            'referringPlatform',
            'referringPlatforms',
            'referringPlatformUuid',
            'referringPlatformReturnUrl',
            'referringPlatformListingId',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'isArchived',
            'disableSignatureReminders',
            'disableClosingInfoReminders',
            'disclosureOnboardingComplete',
            'isFinalized',
            'isRexOrder',
            'ignoreInReportsAuto',
            'ignoreInReportsManual',
            'closingDate',
            'price',
            'disclosureCompletePercent',
            'disclosureStepIndex',
            'statusPriority',
            'agentWithoutAccount',
            'agentEntryToken',
            'sellerEntryToken',
            'coordinatorEmail',
            'promoCode',
            'stripeChargeId',
            'titleCompanyName',
            'zohoId',
            'quickbooksInvoiceId',
            'additionalLegalOwners',
            'segment',
            'eulaAcceptedByIp',
            'paymentReceivedAt',
            'eulaAcceptedAt',
            'closingInfoReminderLastSentAt',
            'signatureReminderLastSentAt',
            'disclosureAwaitingSignaturesStatusLastSetAt',
            'postDisclosureUpsellFirstViewedByPrimarySellerAt',
            'prepareToSignPageFirstViewedByPrimarySellerAt',
            'transactionCoordinatorUuid',
            'agentUuid',
            'brokerUuid',
            'orderedById',
            'statusId',
            'solutionPurchasedId',
            'paymentTermId',
            'primaryDisclosureFormId',
            'sellers',
            'forms',
            'invitation',
            'escrowOfficer',
            'homeSaleLegalProtection',
            'escrowInvoiceToken',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            transactionCoordinator: UserAppResource,
            agent: UserAppResource,
            property: OrderPropertyAppResource,
            homeSaleLegalProtection: HomeSaleLegalProtectionAppResource,
            escrowOfficer: EscrowOfficerAppResource,
            disclosure: DisclosureAppResource,
            invitation: InvitationAppResource,
            sellers: SellerAppResource,
            orderedBy: LuOrderedByTypeAppResource,
            status: LuOrderStatusAppResource,
            solutionPurchased: LuOrderSolutionAppResource,
            signDisclosure: SignDisclosureAppResource,
            paymentTerm: LuOrderPaymentTermAppResource,
            primaryDisclosureForm: LuDisclosureFormAppResource,
            broker: BrokerAppResource,
            forms: FormAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            transactionCoordinator: 'transaction_coordinator_uuid',
            agent: 'agent_uuid',
            orderedBy: 'ordered_by_id',
            status: 'status_id',
            solutionPurchased: 'solution_purchased_id',
            paymentTerm: 'payment_term_id',
            primaryDisclosureForm: 'primary_disclosure_form_id',
            broker: 'broker_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            closingDate: {
                datetime: true,
            },
            titleCompanyName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

    apiPaths() {
        return {
            ...super.apiPaths(),
            'resendInvite': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/resend-invite'),
            'runUpdate': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/update'),
            'messageSeller': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/message-seller?messageType={messageType}'),
            'hslpShown': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/hslp-shown')
        }
    }

    async resendInvite(data) {
        const url = this.apiPaths().resendInvite.replace('{uuid}', this.uuid);

        return await Engine.get(url, {
            ...data,
        });
    }

    async runUpdate() {
        const url = this.apiPaths().runUpdate.replace('{uuid}', this.uuid);
        const updateData = super.buildUpdateData();


        return await Engine.post(url, {
            ...updateData,
        });
    }

    async messageSeller(messageType) {
        let url = this.apiPaths().messageSeller.replace('{uuid}', this.uuid);
        url = url.replace('{messageType}', messageType);

        return await Engine.get(url);
    }

    async hslpShown(page, shown = false){
        let url = this.apiPaths().hslpShown.replace('{uuid}', this.uuid);
        return await Engine.post(url, {
            shown: shown,
            page: page
        });
    }

}

export default OrderAppResource;
